import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OmniGateway } from '@cigna/omni/shared';
import { Observable } from 'rxjs';
import { UserEvent } from '../models';

@Injectable({
  providedIn: 'root',
})
export class PollingDataAccessService {
  constructor(private http: HttpClient, private gateway: OmniGateway) {}

  public getEvents(): Observable<UserEvent[]> {
    const url = this.gateway.userEventsUrl();
    return this.http.get<UserEvent[]>(url);
  }
}
